import React from 'react';
import { textColor } from '@atlaskit/adf-schema';
import { changeColor as _changeColor } from './commands/change-color';
import { createPlugin, pluginKey as textColorPluginKey } from './pm-plugins/main';
import { PrimaryToolbarComponent } from './ui/PrimaryToolbarComponent';
var pluginConfig = function pluginConfig(textColorConfig) {
  if (!textColorConfig || typeof textColorConfig === 'boolean') {
    return undefined;
  }
  return textColorConfig;
};
export var textColorPlugin = function textColorPlugin(_ref) {
  var textColorConfig = _ref.config,
    api = _ref.api;
  return {
    name: 'textColor',
    marks: function marks() {
      return [{
        name: 'textColor',
        mark: textColor
      }];
    },
    pmPlugins: function pmPlugins() {
      return [{
        name: 'textColor',
        plugin: function plugin(_ref2) {
          var dispatch = _ref2.dispatch;
          return createPlugin(dispatch, pluginConfig(textColorConfig));
        }
      }];
    },
    getSharedState: function getSharedState(editorState) {
      if (!editorState) {
        return undefined;
      }
      return textColorPluginKey.getState(editorState);
    },
    actions: {
      changeColor: function changeColor(color) {
        var _api$analytics;
        return _changeColor(color, api === null || api === void 0 || (_api$analytics = api.analytics) === null || _api$analytics === void 0 ? void 0 : _api$analytics.actions);
      }
    },
    primaryToolbarComponent: function primaryToolbarComponent(_ref3) {
      var editorView = _ref3.editorView,
        popupsMountPoint = _ref3.popupsMountPoint,
        popupsBoundariesElement = _ref3.popupsBoundariesElement,
        popupsScrollableElement = _ref3.popupsScrollableElement,
        isToolbarReducedSpacing = _ref3.isToolbarReducedSpacing,
        dispatchAnalyticsEvent = _ref3.dispatchAnalyticsEvent,
        disabled = _ref3.disabled;
      return /*#__PURE__*/React.createElement(PrimaryToolbarComponent, {
        isReducedSpacing: isToolbarReducedSpacing,
        editorView: editorView,
        popupsMountPoint: popupsMountPoint,
        popupsBoundariesElement: popupsBoundariesElement,
        popupsScrollableElement: popupsScrollableElement,
        dispatchAnalyticsEvent: dispatchAnalyticsEvent,
        disabled: disabled,
        api: api
      });
    }
  };
};
export { textColorPluginKey };